import { Plus } from "lucide-react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/app/components/ui/button";
import type { ResumeContextValue } from "@/app/types/resume";

import tips from "../../../../../assets/copy/tips";
import ReferenceSummaryBox from "../../../../../components/ResumeBuilder/ReferenceSummaryBox/ReferenceSummaryBox";
import Tips from "../../../../../components/Tips";
import ResumeContext from "../../../../../context/ResumeContext";

const ReferenceSummary = () => {
	const navigate = useNavigate();
	const { resumeData } = useContext(ResumeContext) as ResumeContextValue;
	const { references } = resumeData.extras;

	const addAnotherEduHandler = () => {
		navigate("/resume/reference-information");
	};

	return (
		<div className="min-h-screen">
			<div className="w-full md:max-w-3xl">
				<div className="mb-2 flex justify-end">
					<Tips content={tips.referees} />
				</div>
				{references.length === 0 ? (
					<div className="flex justify-center text-gray-900">
						<h5 className="m-3 font-semibold">No Referee Information Added</h5>
					</div>
				) : (
					references.map((reference, index) => {
						return <ReferenceSummaryBox key={index} item={reference} />;
					})
				)}

				<button
					type="button"
					className="mt-3 flex cursor-pointer items-center gap-3 font-semibold text-primary-700"
					onClick={addAnotherEduHandler}
				>
					<Plus className="size-4" />
					Add another reference
				</button>

				<div className="mt-4 flex w-full items-center justify-end gap-3">
					<Button type="button" onClick={() => navigate("/resume/extras")} variant="ghost">
						Skip for now
					</Button>
					<Button
						type="button"
						onClick={() => {
							navigate("/resume/extras");
						}}
					>
						Continue
					</Button>
				</div>
			</div>
		</div>
	);
};

export default ReferenceSummary;
